import { render, staticRenderFns } from "./marketingAdd.vue?vue&type=template&id=e119cb3a&scoped=true&"
import script from "./marketingAdd.vue?vue&type=script&lang=js&"
export * from "./marketingAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e119cb3a",
  null
  
)

export default component.exports